export enum DisplayType {    
    All = 1,
    MenuOnly = 2,
    TabsOnly = 3,
    NoMenuNoTabs = 4
}